<script>
import { Table } from 'vhtml-ui';

const DEFAULT_EXTRA_PARAMS = {
    index: 1,
    count: 15,
    sortType: undefined,
    sortKey: undefined
};

export default {
    name: 'Grid',
    props: {
        url: String,
        // use url if subUrl is empty
        subUrl: String,
        params: {
            type: Object,
            default: () => {
                return {
                    // index: 1,
                    // count: 15
                };
            }
        },
        showQuick: {
            type: Boolean,
            default: false
        },
        subKeys: Array,
        // 初始数据是否已经产生(如果有，初始数据给data)
        initalData: Boolean,
        method: {
            type: String,
            default: 'get'
        },
        fetch: {
            type: Function,
            default: function(url, params) {
                return this.$ajax[this.method || 'get'](url, { params });
                // return this.$ajax.request({
                //     url: url,
                //     method: this.method || 'get',
                //     params: params
                // });
            }
        },
        dataPath: {
            type: String,
            default: '/records'
        },
        totalPath: {
            type: String,
            default: '/total'
        },
        formatData: {
            type: Function,
            default: function(data) {
                while (data.data) {
                    data = data.data;
                }
                return data;
            }
        },
        paramsAlies: {
            type: Object,
            default: () => {
                return {
                    index: 'index',
                    count: 'count',
                    sortType: 'sortType',
                    sortKey: 'sortKey'
                };
            }
        },
        ...Table.props,
        auto: {
            type: Boolean,
            default: false
        },
        fetchError: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let extraParams = {};
        Object.keys(this.paramsAlies).forEach(key => {
            this.$set(
                extraParams,
                this.paramsAlies[key],
                (this.pagination && this.pagination[key]) || DEFAULT_EXTRA_PARAMS[key]
            ); // eslint-disable-line
        });
        return {
            tData: this.data || [],
            tPagination:  {...this.pagination, showQuick: this.showQuick} || {},
            tLoading: false,
            subParams: [],
            extraParams: extraParams
        };
    },
    computed: {
        extra() {
            return !this.auto
                ? {
                      data: this.tData,
                      pagination: this.tPagination,
                      loading: this.tLoading && !this.fetchError,
                      singleExpand: true,
                      context: this.context || (this.$vnode && this.$vnode.context)
                  }
                : {};
        }
    },
    watch: {
        params: {
            handler: function() {
                this.$set(this.tPagination, 'index', 1);
                if (!this.fetching) {
                    this.fetching = true;
                    let that = this;
                    this.$nextTick(function() {
                        that.update();
                        that.fetching = false;
                    });
                }
            },
            deep: true
        },
        extraParams: {
            handler: function() {
                if (!this.fetching) {
                    this.fetching = true;
                    let that = this;
                    this.$nextTick(function() {
                        that.update();
                        that.fetching = false;
                    });
                }
            },
            deep: true
        },
        url() {
            // console.log('url changesd');
        }
    },
    created() {
        this.fetchCount = 0;
        if (!this.initalData) {
            // this.$set(this.extraParams, this.paramsAlies.index, 1);
            // this.$set(this.extraParams, this.paramsAlies.count, 15);
            // 无初始化数据时，自动请求一次数据
            this.update();
        }
    },
    methods: {
        subLoading(props) {
            // return (<div class="v-table-sub-loading">loading</div>)
            return (
                <div class="v-table-sub-loading">
                    <i class="loading" />
                </div>
            );
        },
        loadMore(props) {
            return [
                <span class="v-table__td--indentele" style={{ width: this.indentWidth + 'px' }} />,
                <div class="v-table-sub-more" on-click={() => this.handleLoadMore(props.row, props.index)}>
                    展开更多
                </div>
            ];
        },
        update() {
            // reset subparams
            this.subParams = [];
            this.tLoading = true;

            let that = this;
            let currentCount = ++this.fetchCount;
            this.fetchData(this.url, Object.assign({}, this.params, this.extraParams)).then(
                function(data) {
                    if (currentCount === that.fetchCount) {
                        let responseData = that.parseData(data.data || data);
                        that.tData = responseData.data;
                        that.tPagination.total = parseInt(responseData.total, 10) || 0;
                        that.$emit('update', that.tData, that.tPagination, data.ext);
                    }
                    // that.cancelSource = undefined;
                },
                function(e) {
                    currentCount === that.fetchCount && (that.tLoading = false);
                    // that.cancelSource = undefined;
                }
            );
        },
        fetchData(url, params) {
            let pm = this.fetch(url, params);
            if (!pm || !pm.then) {
                pm = new Promise(function(resolve, reject) {
                    reject('invalid fetch function');
                });
            }
            return pm;
        },
        fetchSub(params, resolve, reject) {
            if (this.fetch) {
                let pm = this.fetch(this.url || this.subUrl, params);
                if (pm.then) {
                    pm.then(resolve, reject);
                    return pm;
                }
            }
        },
        parseData(response) {
            response = this.formatData(response);
            let data = response;
            let total = response;
            let dataPath = (this.dataPath || '').split('/');
            dataPath.map(path => {
                path && data && (data = data[path]);
            });
            let totalPath = (this.totalPath || '').split('/');
            totalPath.map(path => {
                path && data && (total = total[path]);
            });
            // this.$props.data = data;
            // this.$props.pagination.total = total;
            this.tLoading = false;
            return {
                data: data,
                total: parseInt(total, 10) || 0
            };
        },
        paginationChange(index, pageSize) {
            let current = index;
            // 如果每页数量发生变化，就要重置页码。
            const preCount = this.extraParams[this.paramsAlies.count];
            if(preCount && preCount !== pageSize){
                this.tPagination.index = 1;
                current = 1;
            }
            this.$set(this.extraParams, this.paramsAlies.index, current);
            this.$set(this.extraParams, this.paramsAlies.count, pageSize);
            this.$emit('pageChange', {current, pageSize});
        },
        sort(sortOrder, sortKey) {
            console.log(sortOrder);
            this.tPagination.current = 1;
            this.$set(this.extraParams, this.paramsAlies.index, 1);
            this.$set(this.extraParams, this.paramsAlies.sortType, sortOrder);
            this.$set(this.extraParams, this.paramsAlies.sortKey, sortKey);
            this.$emit('sort', { sortType: sortOrder, sortKey: sortKey });
        },
        refreshList() {
            this.tPagination.index = 1;
            this.tPagination.current = 1;
            this.$set(this.extraParams, this.paramsAlies.index, 1);
        },
        rowExpand(row, rowIndex) {
            if (!this.subUrl && row.children && row.children.length > 0) {
                return;
            }

            let subParam = (this.subParams[rowIndex] = {});
            subParam[this.paramsAlies.sortType] = this.extraParams[this.paramsAlies.sortType];
            subParam[this.paramsAlies.sortKey] = this.extraParams[this.paramsAlies.sortKey];
            subParam[this.paramsAlies.index] = 1;
            subParam[this.paramsAlies.count] = 10;

            (this.subKeys || []).map(key => {
                if (typeof key === 'string') {
                    subParam[key] = row[key];
                } else {
                    subParam = Object.assign(subParam, key);
                }
            });

            let that = this;
            that.$set(row, 'customRow', that.subLoading);
            that.fetchData(this.subUrl, subParam).then(
                data => {
                    let responseData = that.parseData(data.response || data);
                    that.$set(row, 'children', responseData.data);
                    if (responseData.total > row.children.length) {
                        that.$set(row, 'customRow', that.loadMore);
                    } else {
                        that.$set(row, 'customRow', undefined);
                    }
                },
                e => {
                    subParam.index--;
                    that.$set(row, 'customRow', undefined);
                }
            );
        },
        rowClick(row, rowIndex) {
            this.$emit('rowClick', row, rowIndex);
        },
        handleLoadMore(row, index) {
            let subParam = this.subParams[index] || {};
            subParam[this.paramsAlies.index]++;
            let that = this;
            that.fetchData(this.subUrl, subParam).then(
                data => {
                    let responseData = that.parseData(data.data || data);
                    row.children = row.children.concat(responseData.data);
                    if (responseData.total > row.children.length) {
                        that.$set(row, 'customRow', that.loadMore);
                    } else {
                        that.$set(row, 'customRow', undefined);
                    }
                },
                e => {
                    subParam.index--;
                    that.$set(row, 'customRow', undefined);
                }
            );
        },
        selection(selectedRows) {
            this.$emit('selection', selectedRows);
        },
        selectHeadAll(obj) {
            this.$emit('selectHeadAll', obj);
        }
    },
    render(h) {
        let events = !this.auto
            ? {
                  paginationChange: this.paginationChange,
                  rowExpand: this.rowExpand,
                  sort: this.sort,
                  rowClick: this.rowClick,
                  selection: this.selection,
                  selectHeadAll: this.selectHeadAll
              }
            : {};

        let nodata;
        if (this.$slots.nodata) {
            nodata = h(
                'template',
                {
                    slot: 'nodata'
                },
                this.$slots.nodata
            );
        }

        return h(
            'v-table',
            {
                props: Object.assign({}, this.$props, this.extra),
                scopedSlots: {
                    expandRow: this.$scopedSlots.expandRow
                },
                on: events
            },
            nodata ? [nodata].concat(this.$slots.default) : this.$slots.default
        );
    },
    components: {
        VTable: Table
    }
};
</script>

<style lang="less">
@import './style.less';
</style>
